/**
 * NEXORA AI - RegionStep (Refactorisé avec Design System)
 * Epic 1.3 Phase 2.2 - Onboarding Premium
 * 
 * Utilise : SelectionCard, StepHeader, ValidationMessage
 * Standard : Goals Step (référence visuelle)
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import SelectionCard, { SelectionCardGrid } from '../ui/selection-card';
import StepHeader from '../ui/step-header';
import ValidationMessage from '../ui/validation-message';

const REGIONS = [
  { id: 'global', label: 'region_global', icon: '🌍' },
  { id: 'africa', label: 'region_africa', icon: '🌍' },
  { id: 'asia', label: 'region_asia', icon: '🌏' },
  { id: 'europe', label: 'region_europe', icon: '🌍' },
  { id: 'oceania', label: 'region_oceania', icon: '🌏' },
  { id: 'americas', label: 'region_americas', icon: '🌎' }
];

export default function RegionStep({ data, onNext, onBack, onData }) {
  const { t } = useTranslation('onboarding');
  const [selected, setSelected] = useState(data.region || null);
  const [showValidation, setShowValidation] = useState(false);

  const handleSelect = (regionId) => {
    setSelected(regionId);
    onData({ region: regionId });
  };

  const handleNext = () => {
    if (selected) {
      setShowValidation(true);
      setTimeout(() => onNext(), 1200);
    }
  };

  // Container animation
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.08, delayChildren: 0.1 }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 sm:p-6">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-4xl"
      >
        {/* Header avec StepHeader */}
        <StepHeader
          icon={<Globe className="text-blue-400" />}
          title={t('region_title')}
          subtitle={t('region_subtitle')}
        />

        {/* Grid de sélection avec SelectionCard */}
        <SelectionCardGrid cols={3} className="mb-8">
          {REGIONS.map((region) => (
            <SelectionCard
              key={region.id}
              id={region.id}
              selected={selected === region.id}
              onSelect={handleSelect}
              icon={region.icon}
              title={t(region.label)}
              size="md"
              testId={`region-${region.id}`}
            />
          ))}
        </SelectionCardGrid>

        {/* Message de valorisation */}
        <ValidationMessage
          show={showValidation}
          type="success"
          message={t('validation_region')}
        />

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Button
            variant="ghost"
            onClick={onBack}
            className="min-h-[44px] text-zinc-400 hover:text-white"
          >
            {t('back')}
          </Button>
          <Button
            onClick={handleNext}
            disabled={!selected || showValidation}
            className="min-h-[44px] bg-blue-600 hover:bg-blue-500"
          >
            {t('continue')}
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
